import api from "@/assets/js/api"; // 引用統一的 API 模塊
import Cookies from "js-cookie";
import Swal from "sweetalert2"; // 引入 SweetAlert2 用於提示訊息

export default {
  data() {
    return {
      rooms: [], // 存放房型資料
      currentStep: 1, // 預設為第一步
      orders: [], // 存放訂單資料
      showEmptyCartMessage: false,
      isLoading: false, // ✅ 添加 isLoading 到 data 中
      paymentMethod: "", // 使用者選擇的付款方式
      buyerInfo: {
        lastName: "",
        firstName: "",
        email: "",
        phone: "",
        gender: "",
        birthYear: "",
        birthMonth: "",
        birthDay: "",
      },
      remarks: "", // 備註
      termsAccepted: false, // 條款是否已確認
      orderSummary: {
        totalAmount: 0, // 訂單總金額
        serviceFee: 0, // 服務費（10%）
        grandTotal: 0, // 總金額
      },
    };
  },
  methods: {
    async fetchOrders() {
      try {
        this.isLoading = true; // 開始加載
        this.showEmptyCartMessage = false;

        console.log("正在從後端獲取訂單資料...");

        const token = Cookies.get("token");
        if (!token) {
          Swal.fire({
            icon: "warning",
            title: "驗證失敗",
            text: "未找到登入憑證，請重新登入！",
            confirmButtonText: "確定",
          });
          this.$router.push("/login");
          return;
        }

        // ✅ 使用攔截器，不需要手動添加 headers
        const response = await api.get("/Cart");
        const data = response.data;

        console.log("後端返回的購物車資料：", data);

        // ✅ 檢查資料是否為空
        if (!data || data.length === 0) {
          this.orders = [];
          this.calculateSummary();
          console.log("購物車目前為空");
          this.showEmptyCartMessage = true;
          return;
        }

        this.showEmptyCartMessage = false;

        // ✅ 根據實際 API 結構處理資料
        this.orders = data.flatMap((cart) =>
          cart.Details.map((detail) => {
            // 注意是大寫的 Details
            return {
              id: cart.Id, // 購物車 ID
              cartDetailId: detail.Id, // 購物車詳細項目 ID
              roomId: detail.RoomId, // 房間 ID
              roomNumber: detail.RoomNumber, // 房間號碼
              roomType: detail.RoomTypeName, // 房型名稱
              checkInDate: new Date(detail.CheckInDate).toLocaleDateString(
                "zh-TW"
              ),
              checkOutDate: new Date(detail.CheckOutDate).toLocaleDateString(
                "zh-TW"
              ),
              nights: detail.StayNights, // 住宿天數
              package: detail.PackageName || "純住宿", // 套餐名稱
              unitPrice: detail.UnitPrice, // 單價
              quantity: 1, // 房間數量固定為1
              totalPrice: detail.UnitPrice * detail.StayNights, // 計算總價 = 單價 × 天數
            };
          })
        );

        console.log("整理後的購物車資料：", this.orders);
        this.calculateSummary();
      } catch (error) {
        console.error("=== 錯誤詳細資訊 ===");
        console.error("錯誤物件:", error);
        console.error("回應狀態:", error.response?.status);
        console.error("回應資料:", error.response?.data);
        console.error("====================");

        if (error.response?.status === 404) {
          this.orders = [];
          this.calculateSummary();
          this.showEmptyCartMessage = true;
          console.log("購物車為空或找不到購物車資料");
        } else {
          Swal.fire({
            icon: "error",
            title: "購物車載入失敗",
            text: `無法加載購物車資料：${
              error.response?.data || error.message
            }`,
            confirmButtonText: "確定",
          });
        }
      } finally {
        this.isLoading = false; // 結束加載
      }
    },

    // 計算訂單摘要
    calculateSummary() {
      // 計算總金額
      const totalAmount = this.orders.reduce(
        (sum, order) => sum + order.totalPrice,
        0
      );

      // 計算服務費（10%）
      const serviceFee = Math.round(totalAmount * 0.1);

      // 計算總金額（總金額 = 訂單金額 + 服務費）
      const grandTotal = totalAmount + serviceFee;

      // 更新訂單摘要數據
      this.orderSummary = {
        totalAmount,
        serviceFee,
        grandTotal,
      };

      console.log("訂單摘要計算完成：", this.orderSummary);
    },

    // ✅ 修正移除訂單方法
    async removeOrder(index, cartDetailId) {
      try {
        const result = await Swal.fire({
          title: "確認移除",
          text: "確定要移除此訂單嗎？",
          icon: "warning",
          showCancelButton: true,
          confirmButtonColor: "#d33",
          cancelButtonColor: "#3085d6",
          confirmButtonText: "確定移除",
          cancelButtonText: "取消",
        });

        if (!result.isConfirmed) {
          return;
        }

        console.log("準備移除購物車項目，cartDetailId:", cartDetailId);

        // ✅ 使用正確的 URL 路徑，讓攔截器處理 Authorization
        const response = await api.delete(
          `/Cart/RemoveCartDetail/${cartDetailId}`
        );

        console.log("移除成功，後端回應:", response.data);

        // 從前端陣列中移除
        this.orders.splice(index, 1);

        // 檢查是否購物車已空
        if (this.orders.length === 0) {
          this.showEmptyCartMessage = true;
        }

        this.calculateSummary(); // 重新計算摘要

        Swal.fire({
          icon: "success",
          title: "移除成功",
          text: "訂單已成功移除！",
          confirmButtonText: "確定",
        });
      } catch (error) {
        console.error("移除訂單失敗：", error);
        console.error("錯誤詳情:", {
          status: error.response?.status,
          data: error.response?.data,
          config: error.config,
        });

        let errorMessage = "無法移除訂單，請稍後再試！";

        if (error.response?.status === 404) {
          errorMessage = "找不到要移除的項目！";
        } else if (error.response?.data?.Message) {
          errorMessage = error.response.data.Message;
        }

        Swal.fire({
          icon: "error",
          title: "移除失敗",
          text: errorMessage,
          confirmButtonText: "確定",
        });
      }
    },

    // ✅ 改善 Cookie 獲取方法
    getEmailFromCookie() {
      // 1️⃣ 先嘗試直接從 cookie 拿 email
      const emailFromCookie = Cookies.get("email");
      if (emailFromCookie) {
        return emailFromCookie; // ← 控制 Cookie 區域
      }

      // 2️⃣ 從 JWT token 解析 email（正確 Base64URL）
      const token = Cookies.get("token");
      if (!token) return null;

      try {
        const payloadBase64 = token.split(".")[1]; // JWT payload 區域
        const base64 = payloadBase64
          .replace(/-/g, "+") // Base64URL → Base64
          .replace(/_/g, "/"); // Base64URL → Base64

        const payloadJson = decodeURIComponent(
          atob(base64)
            .split("")
            .map((c) => "%" + ("00" + c.charCodeAt(0).toString(16)).slice(-2))
            .join("")
        );

        const payload = JSON.parse(payloadJson); // 解析 payload JSON
        return payload.email || null; // 回傳 email 欄位
      } catch (error) {
        console.error("JWT 解析失敗:", error);
        return null;
      }
    },
    goToBooking() {
      this.$router.push("/booking");
    },

    // 返回上一頁邏輯
    goBack() {
      if (this.currentStep > 1) {
        this.currentStep--;
      } else {
        Swal.fire({
          icon: "info",
          title: "操作提示",
          text: "目前已經是第一步驟，無法返回！",
          confirmButtonText: "確定",
        });
      }
    },

    // ✅ 修正下一步邏輯，增加完整驗證
    async goNext() {
      if (this.currentStep === 1) {
        // ✅ 檢查是否有商品才能進入下一步
        if (this.orders.length === 0) {
          Swal.fire({
            icon: "warning",
            title: "購物車為空",
            text: "請先加入商品到購物車！",
            confirmButtonText: "確定",
          });
          return;
        }
        this.currentStep++;
      } else if (this.currentStep === 2) {
        // ✅ 驗證必填欄位
        if (!this.buyerInfo.lastName.trim()) {
          Swal.fire({
            icon: "warning",
            title: "請填寫姓名",
            text: "姓名為必填欄位！",
            confirmButtonText: "確定",
          });
          return;
        }

        if (!this.buyerInfo.email.trim()) {
          Swal.fire({
            icon: "warning",
            title: "請填寫電子信箱",
            text: "電子信箱為必填欄位！",
            confirmButtonText: "確定",
          });
          return;
        }

        // ✅ 簡單的 email 格式驗證
        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        if (!emailRegex.test(this.buyerInfo.email)) {
          Swal.fire({
            icon: "warning",
            title: "電子信箱格式錯誤",
            text: "請輸入正確的電子信箱格式！",
            confirmButtonText: "確定",
          });
          return;
        }

        if (!this.buyerInfo.phone.trim()) {
          Swal.fire({
            icon: "warning",
            title: "請填寫手機號碼",
            text: "手機號碼為必填欄位！",
            confirmButtonText: "確定",
          });
          return;
        }

        // ✅ 簡單的手機號碼格式驗證
        const phoneRegex = /^09\d{8}$/;
        if (!phoneRegex.test(this.buyerInfo.phone)) {
          Swal.fire({
            icon: "warning",
            title: "手機號碼格式錯誤",
            text: "請輸入正確的手機號碼格式（例：0912345678）！",
            confirmButtonText: "確定",
          });
          return;
        }

        if (!this.buyerInfo.gender) {
          Swal.fire({
            icon: "warning",
            title: "請選擇性別",
            text: "性別為必填欄位！",
            confirmButtonText: "確定",
          });
          return;
        }

        if (!this.paymentMethod) {
          Swal.fire({
            icon: "warning",
            title: "請選擇付款方式",
            text: "請先選擇付款方式後再繼續！",
            confirmButtonText: "確定",
          });
          return;
        }

        if (!this.termsAccepted) {
          Swal.fire({
            icon: "warning",
            title: "請同意條款",
            text: "請先閱讀並勾選我已同意服務條款才能繼續。",
            confirmButtonText: "確定",
          });
          return;
        }

        try {
          const email = this.getEmailFromCookie();
          if (!email) {
            Swal.fire({
              icon: "error",
              title: "身份驗證失敗",
              text: "無法找到使用者的 Email，請重新登入！",
              confirmButtonText: "確定",
            });
            return;
          }

          await this.submitOrder(email);
          this.currentStep++;
        } catch (error) {
          console.error("提交訂單時發生錯誤：", error);
          Swal.fire({
            icon: "error",
            title: "提交失敗",
            text: "訂單提交失敗，請稍後重試！",
            confirmButtonText: "確定",
          });
        }
      } else {
        Swal.fire({
          icon: "info",
          title: "操作提示",
          text: "目前已經是最後一步驟！",
          confirmButtonText: "確定",
        });
      }
    },

    // 返回首頁的方法
    goToHome() {
      this.$router.push("/");
    },

    // ✅ 修正提交訂單方法
    async submitOrder() {
      try {
        const response = await api.post(`/Order`, {
          checkInName: this.buyerInfo.lastName,
          email: this.buyerInfo.email,
          phone: this.buyerInfo.phone,
          gender: this.buyerInfo.gender === "male",
          notes: this.remarks,
          paymentMethod: this.paymentMethod,
        });

        console.log("提交訂單成功：", response.data);

        // ✅ 使用 SweetAlert2 而不是 alert
        Swal.fire({
          icon: "success",
          title: "訂房完成",
          text: response.data.message || "您的訂單建立成功！",
          confirmButtonText: "確定",
        });
      } catch (error) {
        console.error("提交訂單失敗：", error.response || error.message);
        throw error; // 重新拋出錯誤讓上層處理
      }
    },

    async clearCart(email) {
      try {
        const response = await api.delete(`/Cart/ClearCart/${email}`);
        console.log("清空購物車成功：", response.data);

        // ✅ 清空購物車後更新前端狀態
        this.orders = [];
        this.calculateSummary();
      } catch (error) {
        console.error("清空購物車失敗：", error.response || error.message);
        // 清空購物車失敗不影響主流程，只記錄錯誤
      }
    },

    showTermsInfo() {
      console.log("顯示條款資訊");

      Swal.fire({
        title: "預訂條款提醒",
        html: `
          <div style="text-align: left; line-height: 1.6;">
            <h4 style="color: #e74c3c; margin-bottom: 15px;">
              ⚠️ 重要提醒
            </h4>
            <p style="font-size: 16px; font-weight: bold; color: #e74c3c; margin-bottom: 10px;">
              📅 未付款訂單僅保留房間 3 天
            </p>
            <ul style="margin: 15px 0; padding-left: 20px;">
              <li>訂單成立後，請於 <strong>3 天內</strong> 完成付款</li>
              <li>逾期未付款，訂單將自動取消</li>
              <li>房間將重新開放給其他客人預訂</li>
              <li>如需延期付款，請提前聯繫客服</li>
            </ul>
            <hr style="margin: 15px 0;">
            <h4 style="color: #2c3e50; margin-bottom: 10px;">其他條款：</h4>
            <ul style="margin: 10px 0; padding-left: 20px; font-size: 14px;">
              <li>入住時請攜帶有效身分證件</li>
              <li>退房時間為當日上午 11:00</li>
              <li>取消政策依房型而異，詳見訂單確認信</li>
              <li>房間內禁止吸菸</li>
            </ul>
          </div>
        `,
        icon: "info",
        confirmButtonText: "我已了解",
        confirmButtonColor: "#3085d6",
        width: "500px",
        showCloseButton: true,
        customClass: {
          htmlContainer: "terms-info-content",
        },
      }).catch((error) => {
        console.error("SweetAlert2 錯誤:", error);
        alert("未付款訂單僅保留房間 3 天，請於 3 天內完成付款！");
      });
    },

    // ✅ 也可以提供手動點擊條款文字的方法
    handleTermsClick() {
      console.log("手動點擊條款文字");
      this.showTermsInfo();
    },
  },
  watch: {
    termsAccepted(newValue, oldValue) {
      console.log("條款勾選狀態改變:", { 新值: newValue, 舊值: oldValue });

      // 只有當從 false 變為 true 時才顯示提醒
      if (newValue === true && oldValue === false) {
        console.log("使用者勾選了條款，顯示條款提醒");
        this.showTermsInfo();
      }
    },
  },
};
